var React = require('react');

function SocialStrava (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M41.03 47.852l-5.572-10.976h-8.172L41.03 64l13.736-27.124h-8.18","key":0}),React.createElement("path",{"d":"M27.898 21.944l7.564 14.928h11.124L27.898 0 9.234 36.876H20.35","key":1})]);
}

SocialStrava.defaultProps = {"width":"64","height":"64","viewBox":"0 0 64 70"};

module.exports = SocialStrava;

SocialStrava.default = SocialStrava;
